"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECT_DOMAINS = void 0;
var REDIRECT_DOMAINS = ["quintoandar.com.br", "benvi.mx", "5adev.mx", "5adev.com", "inmuebles24.com"];
exports.REDIRECT_DOMAINS = REDIRECT_DOMAINS;